import React from "react";
import Contacts from "../../blocks/contacts/contacts";
import { FooterWrapper } from "./styles.js";

export default function Footer() {
  return (
    <FooterWrapper>
      <Contacts />
    </FooterWrapper>
  );
}
